function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5291"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154444",
    style: {
      fill: "none"
    },
    d: "M0 0h34v34H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.018-796.611v-8.682h21.032v8.682h-2.035v-6.314h-16.962v6.314zm.68-10.776a1.531 1.531 0 0 1-1.2-.575 2.065 2.065 0 0 1-.5-1.4 2.077 2.077 0 0 1 .494-1.4 1.526 1.526 0 0 1 1.2-.576 1.531 1.531 0 0 1 1.2.575 2.064 2.064 0 0 1 .5 1.4 2.076 2.076 0 0 1-.494 1.4 1.525 1.525 0 0 1-1.198.576zm3.573-.091v-13.509a2.988 2.988 0 0 1 .721-2.015 2.209 2.209 0 0 1 1.732-.838h7.62a2.209 2.209 0 0 1 1.732.838 2.988 2.988 0 0 1 .721 2.015v13.509zm16.1.091a1.531 1.531 0 0 1-1.2-.575 2.065 2.065 0 0 1-.5-1.4 2.077 2.077 0 0 1 .494-1.4 1.526 1.526 0 0 1 1.2-.576 1.531 1.531 0 0 1 1.2.575 2.064 2.064 0 0 1 .5 1.4 2.076 2.076 0 0 1-.494 1.4 1.526 1.526 0 0 1-1.198.576zm-14.066-2.459h8.455v-11.141a.515.515 0 0 0-.118-.349.377.377 0 0 0-.3-.137h-7.62a.377.377 0 0 0-.3.137.515.515 0 0 0-.118.349zm0 0z",
    transform: "translate(-135 826.84)",
    style: {
      fill: "#121212"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.751ab28fac5c86da315cb75679f2c5b0.svg";
export { ForwardRef as ReactComponent };